import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import './HouseType.css';

const url = process.env.REACT_APP_BACKEND_URL;

const HouseType = () => {
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState({
        name: ""
    });
    const navigate = useNavigate();

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (!data.name.trim()) {
            toast.error("House type name is required");
            return;
        }

        try {
            setSubmitting(true);
            const response = await axios.post(`${url}/api/housetype`, { name: data.name.trim() });

            if (response.data.success) {
                toast.success("House type added successfully!");
                setData({ name: "" });
                navigate('/ViewHouseType');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to add house type";
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="district-container">
            <div className="header">
                <h2>Add New House Type</h2>
                <button 
                    onClick={() => navigate('/ViewHouseType')}
                    className="add-button"
                >
                    <Plus size={16} /> View House Types
                </button>
            </div>

            <form className="district-form" onSubmit={onSubmitHandler}>
                <div className="form-group">
                    <label>House Type Name</label>
                    <input
                        type="text"
                        name="name"
                        value={data.name}
                        onChange={onChangeHandler}
                        placeholder="Enter house type name"
                        required
                    />
                </div>

                <div className="form-actions">
                    <button 
                        type="submit" 
                        className="submit-button" 
                        disabled={submitting}
                    >
                        {submitting ? "Processing..." : "Add House Type"}
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/ViewHouseType')}
                        className="cancel-button"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default HouseType;